import type { NodeMock, StatePreset } from "../mock-types";

export const lobbyCreatedMock: NodeMock = {
  label: "Lobby Created",
  description: "Players confirm they have joined the lobby",
  state: (players) => ({
    confirmedPlayers: [players[0]?.userId].filter(Boolean),
    lobbyCode: "XK7-M9R",
    lobbyFields: [
      { key: "lobbyCode", label: "Lobby Name", value: "XK7-M9R", type: "text" },
      { key: "password", label: "Password", value: "rocketleague", type: "password" },
    ],
  }),
  config: {
    timeoutSeconds: 30,
    showLobbyCode: true,
    instructions: "Lobby is ready. Players may now join.",
    labels: {
      title: "Lobby Ready",
      subtitle: "Join the game lobby and confirm below",
    },
  },
};

export const lobbyCreatedPresets: StatePreset[] = [
  {
    label: "Fresh",
    build: ({ defaultState }) => ({
      state: { ...defaultState, confirmedPlayers: [] },
    }),
  },
  {
    label: "Some Confirmed",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        confirmedPlayers: players.slice(0, Math.ceil(players.length / 2)).map((p) => p.userId),
      },
    }),
  },
  {
    label: "All Confirmed",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, confirmedPlayers: players.map((p) => p.userId) },
    }),
  },
];
